<template>
  <div class="container">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :style="{ 'height': haveSmart?'calc(100vh - 4rem)':'100vh'}" class="pullRefresh">
        <div class="navigator hide">
          <i class="el-icon-arrow-left"></i>
          <div>我的车库</div>
          <span></span>
        </div>
        <div class="tips">
          <div class="warning">提示： </div>
          <div class="warning-text"> 
            <span>出险后请在24小时内拨打 “ 110 ”报警 “ 4000813336 ”备案</span>
          </div>
        </div>
        <div class="banner">
          <img src="../../assets/banner_slices/banner@2x.png" alt="">
          <el-popconfirm
            confirm-button-text='确定'
            cancel-button-text='取消'
            icon="el-icon-info"
            icon-color="red"
            title="是否要清除缓存？"
            @onConfirm="clearStorage"
          >
           <div class="hidden-area" slot="reference"></div>
          </el-popconfirm>
        </div>
        <div class="list" v-if="carInfo.length > 0">
          <div class="item" v-for="(item,index) in carInfo" :key="index" >
            <!-- <img @click="goInfo(item)" src="../../assets/logo_null.png" v-real-img="item.carPhoto"> -->
            <!-- <div v-if="item.carPhoto"> -->
              <!-- <img @click="goInfo(item)" class="imgShow" :src="item.carPhoto" > -->
            <van-image @click="goInfo(item)" :src="item.carPhoto" class="imgShow">
                <template v-slot:error>
                    <div  class="imgdivnull">
                        <img @click="goInfo(item)" class="imgnull" src="../../assets/defaultimg.png" />
                    </div>
                    
                </template>
            </van-image>
            <!-- </div> -->
            <!-- <div  v-if="!item.carPhoto" class="imgdivnull">
              <img @click="goInfo(item)" class="imgnull" src="../../assets/defaultimg.png">
              <p class="null_text">车辆图片 暂未获取</p>
            </div> -->
            
            <div class="textDiscription"  v-if="item.suranceStatus == '3' || item.WadingNatureSuranceStatus=='3'">
              <div class="car-name" @click="goInfo(item)">
                <span>{{item.carName}}</span>
                <img src="../../assets/smart.png" class="smart-img" v-if="item.isIntelligence">
              </div>
              <span style="margin-bottom:.2rem;" @click="goInfo(item)">产品颜色：{{item.color}}</span>
              <span @click="goInfo(item)">产品编号：{{item.code}}</span>
              <!-- <span @click="goInfo(item)">保单号：{{item.warrantyNum}}</span> -->
              <span @click="goInfo(item)">铃行保：{{item.btnTxt}}</span>
              <span v-if="item.WadingNatureSuranceStatus!='1'" @click="goInfo(item)">涉水险：{{item.waterBtnTxt}}</span>
              <!-- disabled  1未购买  2已生效 3去上传 4投保中 5已失效  6已退保(待定) -->
              <div v-if="item.suranceStatus == '3' || item.WadingNatureSuranceStatus=='3'" class="upload status3" @click="goTo(item)">投保资料上传</div>
              <!-- <div v-else class="grey" disabled>{{item.btnTxt}}</div> -->
            </div>
            <div class="textDiscription" @click="goInfo(item)" v-else>
              <div class="car-name">
                <span>{{item.carName}}</span>
                <img src="../../assets/smart.png" class="smart-img" v-if="item.isIntelligence">
              </div>
              <span style="margin-bottom:.2rem;">产品颜色：{{item.color}}</span>
              <span>产品编号：{{item.code}}</span>
              <!-- <span>保单号：{{item.warrantyNum}}</span> -->
              <span>
                铃行保：{{item.btnTxt}} 
                <el-button type="text" style="color:#ff4e57;font-weight: bold;padding:0;margin-left:10px" @click.stop="gotoSurance(item)" v-if="item.renewalStatus != 1">续保</el-button>
              </span>             
              <span v-if="item.WadingNatureSuranceStatus!='1'">涉水险：{{item.waterBtnTxt}}</span>
              <!-- disabled  1未购买  2已生效 3去上传 4投保中 5已失效  6已退保(待定) -->
              <!-- <div v-if="item.suranceStatus == '1'" class="logo_bg"><img src="../../assets/icons/1.png" alt=""></div>
              <div v-if="item.suranceStatus == '2'" class="logo_bg"><img src="../../assets/icons/2.png" alt=""></div>
              <div v-if="item.suranceStatus == '4'" class="logo_bg"><img src="../../assets/icons/4.png" alt=""></div>
              <div v-if="item.suranceStatus == '5'" class="logo_bg"><img src="../../assets/icons/5.png" alt=""></div>
              <div v-if="item.suranceStatus == '6'" class="logo_bg"><img src="../../assets/icons/6.png" alt=""></div>
              <div v-if="item.suranceStatus == '7'" class="logo_bg"><img src="../../assets/icons/7.png" alt=""></div>
              <div v-if="item.suranceStatus == '8'" class="logo_bg"><img src="../../assets/icons/6.png" alt=""></div>
              <div v-if="item.suranceStatus == '9'" class="logo_bg"><img src="../../assets/icons/6.png" alt=""></div> -->
              <!-- <div v-else class="grey" disabled>{{item.btnTxt}}</div> -->
            </div>
          </div>
        </div>
        <!-- <div class="list" style="margin-top:7rem; color:#999;" v-else>暂无车辆</div> -->
        <div class="list" style="margin-top:7rem; color:#999;" v-else></div>
        
    </van-pull-refresh>
    <div class="adv-area" v-if="haveSmart">
      <img src="../../assets/Tips.png">
      <div class="adv">您的车辆中有智能车，华为、OPPO、VIVO、iPhone手机可通过<span>【台铃智能APP】</span>控制使用辆。</div>
      <div class="gotoDown">
        <div class="btn" @click="gotoDown">去下载</div>
      </div>
    </div>
    <Modal :show="showModal" @closeModal="closeModal"></Modal>
  </div>
</template>

<script>
// import {getCars} from '../../apis/myGarage';
import Modal from './components/modal.vue';
import {queryByWx} from '../../apis/carOwner'
import {queryString} from '../../utils/getCodeUrl'
// import axios from 'axios';queryByPhone
// import { parseTime} from '@/utils/index'
export default {
  name: 'myGarage',
  components:{
    Modal
  },
  data() {
    return {
      carInfo: [],
      color: 'red',
      isLoading: true,
      showModal:false,
      mobile: '',
      haveSmart:false,
      code:'',
    }
  },
  beforeRouteEnter(to, from, next) {
        if (!sessionStorage.askPositon ) {
        //当前页面刷新不需要切换位置
        sessionStorage.askPositon = "";
        next();
        } else {
        next(vm => {
            if (vm && document.getElementsByClassName('van-pull-refresh')[0]) {
            setTimeout(function () {
                document.getElementsByClassName('van-pull-refresh')[0].scrollTop = sessionStorage.askPositon;
            }, 150); //同步转异步操作tTime
            }
        });
        }
  },
  beforeRouteLeave(to, from, next) {
    //记录离开时的位置
    sessionStorage.askPositon = document.getElementsByClassName('van-pull-refresh')[0] && document.getElementsByClassName('van-pull-refresh')[0].scrollTop;
    next();
  },
  created() {
    this.mobile = this.$route.params.phone || '';
     this.code = queryString('code')
    // let mobileAndTime = localStorage.getItem('mobileAndTime')
    // if(mobileAndTime){
    //   let data = mobileAndTime.split('&')
    //   if(data[1] > new Date().getTime()){
    //     this.showModal = false
    //     this.mobile = data[0]
        this._getCars(1)
    //     // this.closeModal(data[0])
    //   }else{
    //     this.clearStorage()
    //   }
    // }else{
    //   this.showModal = true
    // }
  },
  methods: {
    onRefresh(){
      this._getCars(2);
    },
    /**
     * @description: 跳转车辆详情
     * @param {*} id
     */
    goInfo(data){
      this.$router.push({ name: 'productInfo',query : {id: data.id, status: data.suranceStatus} })
    },
    /**
     * @description: 获取车库车辆列表数据
     * @param {*}
     */
    _getCars(type) {
    //   let openidKey = 'site_open_id_'+process.env.VUE_APP_NAME
      let param ={
        openId: localStorage.getItem('openid'),
        // openId: 20200706,
      }
      if(this.mobile){
        param.phone = this.mobile
      }
    //   if(this.code){
    //     param = {wxcode:this.code}
    //   }
      console.log('param=',param)
      if(Object.keys(param).length === 0){
        return 
      }
      queryByWx(param).then(res => {
        this.haveSmart = false;
        if(res.status == 2001){
                localStorage.setItem('openid',res.data.openId)
                this.$router.push({path: '/phonelogin?url=myGarage'})
        }
        if (res.status == 2004) {
            localStorage.clear();
            window.reload()
        }
        if(res.status == 0){
          if (res.data.carList.length > 0) {
            res.data.carList.forEach(item => {
              if (item.isIntelligence) {
                this.haveSmart = true
              } 
              switch(item.suranceStatus){
                case '1':
                  item.btnTxt = '未购买';
                  break;
                case '2':
                  item.btnTxt = '已生效'+(item.renewal==1?'(续)':'');
                  break;
                case '3':
                  item.btnTxt = '投保资料上传';
                  break;
                case '4':
                  item.btnTxt = '投保中';
                  break;
                case '5':
                  item.btnTxt = '已失效';
                  break;
                case '7':
                  item.btnTxt = '已拒绝';
                  break;
                case '11':
                  item.btnTxt = '已生效，待确认';
                  break;
                default:
                  item.btnTxt = '已退保';
                  break;
              }
              switch(item.WadingNatureSuranceStatus){
                case '1':
                  item.waterBtnTxt = '未购买';
                  break;
                case '2':
                  item.waterBtnTxt = '已生效';
                  break;
                case '3':
                  item.waterBtnTxt = '投保资料上传';
                  break;
                case '4':
                  item.waterBtnTxt = '投保中';
                  break;
                case '5':
                  item.waterBtnTxt = '已失效';
                  break;
                case '7':
                  item.waterBtnTxt = '已拒绝';
                  break;
                default:
                  item.waterBtnTxt = '已退保';
                  break;
              }
            })
          }
          this.carInfo = res.data.carList;
          if(type == 2){
            setTimeout(() => {
              this.$notify({ type: 'success', message: '刷新成功' });
              this.isLoading = false;
            }, 1000);
          }
        }else{
            localStorage.setItem('openid',res.data.openId)
            this.$notify({ type: 'warning', message: res.msg });
            this.$router.push({
                path: '/phonelogin?url=myGarage'
            })
        }
      })
    },
    clearStorage(){
      localStorage.removeItem('mobileAndTime')
    //   this.showModal = true
    this.$router.push({path: '/phonelogin?url=myGarage'})
    },
    /**
     * @description: 跳转至信息录入页面
     * @param {*} informationEntry: 页面路由名称
     */
    goTo(data) {
      if(data.suranceStatus == '3' || data.WadingNatureSuranceStatus == '3'){
        this.$router.push({ name: 'informationEntry',query: {id: data.id} })
      }
    },
    closeModal(mobile){
      this.mobile = mobile
      this._getCars(1)
      this.showModal = false
      // let openidKey = 'site_open_id_'+process.env.VUE_APP_NAME
      // let data = {
      //   openId:localStorage[openidKey],
      //   phone:mobile
      // }
      // queryByPhone(data).then(res=>{
      //   if(res){
      //     this.showModal = false
      //     this._getCars(1);
      //   }
      // })
    },
    gotoSurance(data){
      if(data.renewalStatus != 0){
        if(data.renewalText){
           this.$toast({
            duration:3000,
            message: data.renewalText,//'您已续保，不支持重复续保',
          })
        }
       
      }else{
        // if((data.suranceEndTime-6*24*3600*1000)<new Date().getTime()){
        //   if((data.carAge+24*3600*1000*365*2)<new Date().getTime()){
        //     this.$toast({
        //       duration:3000,
        //       message:'仅支持24个月以内车龄续保',
        //     })
        //   }else{
            window.location.href = 'https://www.qxbcar.com/index/qxbonlie/policy?no='+data.id
        //   }
        // }else{
        //   this.$toast({
        //     duration:3000,
        //     message:'请在'+parseTime(data.suranceEndTime-6*24*3600*1000,'{y}年{m}月{d}日后')+'，进行续保操作',
        //   })
        // }
      }
    },
    gotoDown() { 
      this.$router.push({
        name:'download'
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import './styles/index.scss';
  .tips{
    position: fixed;
    left:0;
    top:0;
    z-index:999;
    height:0.8rem;
    width:100%;
    line-height: 0.8rem;
    margin:0 auto;
    color:#ff7785;   
    background: #fff6ec;
    font-size:0.6rem;
    font-weight: bold;
    text-align:left;
    .warning{
      width:1.9rem;
      padding-left:0.2rem;
      height:100%;
      float: left;
    }
    .warning-text{
      width:21.2rem;
      height: 100%;
      position: relative;
      float: right;
      overflow: hidden;
      span{
        display: inline-block;
        width:100%;
        white-space:nowrap;
        position: absolute;
        top:0;
        left:100%;
        animation: marqueeTransform 15s linear infinite;
      }
    }
      @keyframes marqueeTransform {
      0% {left:100% }
      100% {left:-100% }
    }
  }
  .imgShow{
    width: 17rem;
  position: absolute;
  top: -1.5rem;
  left: -3rem;
  }
.imgdivnull{
   width: 17rem;
  position: absolute;
  top: 1.5rem;
  left: 0rem;
  .null_text{
    color: #D3D3D4;
    font-size: 12px;
    margin: 8px 0 0 0;
  }
}  .imgnull{
    width: 150px;
    height: 150px;
  }
</style>